"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var storage_base_service_1 = require("./storage-base.service");
var SessionStorage = (function (_super) {
    __extends(SessionStorage, _super);
    function SessionStorage() {
        return _super.call(this, window.sessionStorage) || this;
    }
    return SessionStorage;
}(storage_base_service_1.StorageBase));
exports.SessionStorage = SessionStorage;
//# sourceMappingURL=D:/a/1/s/base/src/session-storage.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/session-storage.service.js